module.exports = __webpack_public_path__ + "static/media/20098C22-46B8-4544-9CA0-D85C8D7AA0C1.a43cb3d7.JPG";